export default "__VITE_PUBLIC_ASSET__f9bd7c6a__"